import { RootState } from '../../../';

export const selectTickets = (state: RootState) => state.tickets.list;
export const selectTicketsMeta = (state: RootState) => state.tickets.listMeta;
export const selectTicketsLoading = (state: RootState) => state.tickets.loading.list;
export const selectSelectedTicketLoading = (state: RootState) =>
  state.tickets.loading.selectedTicket;
export const selectSelectedTicket = (state: RootState) => state.tickets.selectedTicket;
export const selectAttachmentsLoading = (state: RootState) => state.tickets.loading.attachments;
export const selectReplyAttachments = (state: RootState) => state.tickets.replyAttachments;
export const selectTicketsHash = (state: RootState) => state.tickets.listMeta.hash;
export const selectUnreadMessages = (state: RootState) => state.tickets.unreadMessages;
export const selectTicketCreationLoading = (state: RootState) => state.tickets.loading.createTicket;
